module.exports = __webpack_public_path__ + "static/media/nd-logo-2.22568ebc.png";